class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    document.addEventListener('doofinder.cart.add', function (event) {
      setTimeout(()=> {
            try {
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then(response => response.text())
                .then(response => {
                  const html = document.createElement("div");
                  html.innerHTML = response;
                  const newBox = html.querySelector(".cart-drawer").innerHTML;
                  document.querySelector(".cart-drawer").innerHTML = newBox;
                })
            } catch (e) {
              console.log(e)
            }
      }, 800);
    });

     this.initInvoiceBox();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  initInvoiceBox() {
    const box = this.querySelector('.cart-drawer__invoice-box');
    if (!box) return;

    // po każdym przerenderze box jest nowy — ale w obrębie jednego DOM nie binduj 2x
    if (box.dataset.invoiceBound === '1') return;
    box.dataset.invoiceBound = '1';

    const want = box.querySelector('#CartDrawerWantInvoice');
    const company = box.querySelector('#CartDrawerCompany');
    const nip = box.querySelector('#CartDrawerTaxNumber');
    const err = box.querySelector('#CartDrawerInvoiceError');
    const checkout = this.querySelector('#CartDrawer-Checkout');

    if (!want || !company || !nip || !checkout) return;

    // zapamiętaj bazowy stan (np. disabled gdy koszyk pusty)
    const baseCheckoutDisabled = checkout.disabled;

    // checkbox ma być domyślnie odznaczony
    want.checked = false;

    const nipOk = () => /^\d{10}$/.test((nip.value || '').trim());
    const companyOk = () => (company.value || '').trim().length > 1;

    const applyEnabledState = (enabled) => {
      company.disabled = !enabled;
      nip.disabled = !enabled;

      // wymagane tylko gdy faktura
      company.toggleAttribute('required', enabled);
      nip.toggleAttribute('required', enabled);

      if (!enabled) {
        // czyścimy wartości w UI
        company.value = '';
        nip.value = '';
      }
    };

    const refresh = () => {
      const enabled = want.checked;

      applyEnabledState(enabled);

      const ok = !enabled || (companyOk() && nipOk());
      checkout.disabled = baseCheckoutDisabled || (enabled && !ok);

      if (err) err.style.display = (enabled && !ok) ? 'block' : 'none';
    };

    const save = async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'invoice': want.checked ? 'Tak' : '',
              'company_name': want.checked ? (company.value || '').trim() : '',
              'tax_number': want.checked ? (nip.value || '').trim() : ''
            }
          })
        });
      } catch (e) {
        // bez alertów
      }
    };

    let t;
    const debouncedSave = () => {
      clearTimeout(t);
      t = setTimeout(save, 350);
    };

    // Ponieważ checkbox jest zawsze domyślnie OFF, upewnij się,
    // że w koszyku nie zostają stare atrybuty faktury:
    // (to ważne, bo cart attributes inaczej przejdą do zamówienia nawet bez checkboxa)
    save().catch(() => {});

    want.addEventListener('change', () => { refresh(); debouncedSave(); });
    company.addEventListener('input', () => { refresh(); debouncedSave(); });
    nip.addEventListener('input', () => { refresh(); debouncedSave(); });

    refresh();
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      this.initInvoiceBox();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
